const FormDescription = ({title, text}) =>
    <div className="px-4 sm:px-0">
        <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-white">{title}</h3>
        <p className="mt-1 whitespace-pre-wrap text-sm text-gray-600 dark:text-gray-400">{text}</p>
    </div>

export default FormDescription;